import React from 'react'
import { Label } from 'reactstrap'
import styled from 'styled-components'
import get from 'lodash/get'
import find from 'lodash/find'
import moment from '../../../../../lib/moment.js'
import { ShowRemark } from '../../../form'
import RemarkIcon from '../../../../../static/images/remark-icon.svg'
import { FONTS } from '../../../../../constants'

export const Header = class extends React.PureComponent {
  state={ showRemark: false }

  render() {
    const efficiencyResource = get(this.props, 'efficiencyResource')
    const lob_id = get(efficiencyResource, 'efficiencyResource.lob_id')
    const lobs = get(efficiencyResource, 'lobs', [])
    let lob = find(lobs, {
      _id: lob_id,
    })
    lob = lob ? get(lob, 'name', '-') : '-'
    const remark = get(efficiencyResource, 'efficiencyResource.remark')
    const month = get(efficiencyResource, 'efficiencyResource.month')
    const updator = get(efficiencyResource, 'updator')
    const is_submited = get(efficiencyResource, 'efficiencyResource.is_submited')
    const userNotApprovedTimesheets = is_submited ?
      get(efficiencyResource, 'efficiencyResource.efficiency_resource_snapshot.userNotApprovedTimesheets', []) :
      get(efficiencyResource, 'userNotApprovedTimesheets', [])
    return (
      <Wrapper>
        <ShowRemark
          open={ this.state.showRemark }
          month={ moment(month).format('MMMM YYYY') }
          lob={ lob }
          remark={ remark }
          toggle={ () => this.setState({ showRemark: !this.state.showRemark }) }
        />
        <InfoRow>
          <GroupLabel>
            <Title>Status</Title>
            <Detail color={ '#5CB85C' }>
              <Circle color={ '#5CB85C' } />
              { 'Submitted' }
            </Detail>
          </GroupLabel>
          <GroupLabel>
            <Title>Month</Title>
            <Detail>{ moment(month).format('MMMM') }</Detail>
          </GroupLabel>
          <GroupLabel>
            <Title>Year</Title>
            <Detail>{ moment(month).format('YYYY') }</Detail>
          </GroupLabel>
          <GroupLabel>
            <Title>LOB</Title>
            <Detail>{ lob }</Detail>
          </GroupLabel>
          <GroupLabel>
            <Title>Submitted Date</Title>
            <Detail>{ moment(get(efficiencyResource, 'submit_date')).format('DD/MM/YYYY') }</Detail>
          </GroupLabel>
          <GroupLabel>
            <Title>Submitted By</Title>
            <Detail>
              { JSON.stringify(updator) !== JSON.stringify({}) ? `${get(updator, 'first_name')} ${get(updator, 'last_name')} (${get(updator, 'nick_name')})` : '-' }
            </Detail>
          </GroupLabel>
          <GroupLabel>
            <Title>Unapproved Timesheet</Title>
            <Detail>
              { get(userNotApprovedTimesheets, 'length', 0) }
            </Detail>
          </GroupLabel>
          { remark &&
          <GroupLabel>
            <Icon
              src={ RemarkIcon }
              onClick={ () => this.setState({ showRemark: !this.state.showRemark }) }
            />
          </GroupLabel>
          }
        </InfoRow>
        <ButtonRow />
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  background-color: #ffffff ;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  margin-top: 10px;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`
const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 70%;
`
const ButtonRow = styled(InfoRow)`
  width: 30%;
  justify-content: flex-end;
  margin-right: 20px;
`
const GroupLabel = styled.div`
  margin-left: 2%;
`
const Title = styled(Label)`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: 10px;
  color: #A9A9A9;
  margin-right: 10px;
  margin-bottom: 0px;
`
const Detail = styled.span`
  display: flex;
  margin-right: 10px;
  color: ${props => props.color};
`
const Circle = styled.div`
  font-size: 15px;
  color: #FFFFFF;
  text-align: center;
  line-height: 15px;
  height: 10px;
  width: 10px;
  background-color: ${props => props.color};
  border-radius: 50%;
  margin: 5px;
  margin-left: 0px;
`
const Icon = styled.img`
  height: 25px;
  width: 25px;
  margin-right: 5px;
  margin-bottom: auto ;
  margin-top: auto;
  cursor: pointer;
`



// WEBPACK FOOTER //
// ./src/components/efficiency-resource/tab-content/lob-overview/detail/header.js